<template>
  <v-app>
    <v-dialog v-model="dialog.password" persistent
      width="350">
      <v-card 
        class="border-radius pa-2">
        <v-card-text>
          <v-img 
            width="125"
            height="125"
            alt="diskominfo" 
            :src="require('@/assets/icon/info_warning.png')"
            class="ma-auto my-6">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  size="20"
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <div
            class="body-1 text-center line-text-second">
            <div>
              Password Anda sudah dibuat lebih dari 3 bulan
            </div>
            <div>
              Harap Menganti Passwod Anda
            </div>
          </div>

          <v-btn
            to="/profile?menu=password"
            @click="dialog.password = false"
            block
            x-large
            width="170"
            elevation="0"
            class="title font-weight-bold white--text text-capitalize mt-3"
            style="border-radius: 10px; background: #a20000;">
            Ganti Password
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <navbar v-if="token && !$route.path.startsWith('/sidasi')" />
    <navbarSidasi v-if="token && $route.path.startsWith('/sidasi')" />

    <v-main 
      light
      style="background: #F9F9F9;">
      <router-view
        style="padding-left: 2px;" />
    </v-main>
  </v-app>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import firebase from "firebase/app";
  import "firebase/messaging";
  export default {
    data: () => ({
      dialog: {
        password: false
      }
    }),
    components: {
      navbar: () => import(/* webpackPrefetch: true */ '@/components/navbar.vue'),
      navbarSidasi: () => import(/* webpackPrefetch: true */ '@/components/navbar-sidasi.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      token () {
        return this.$store.state.token
      },
      user () {
        return this.$store.state.user
      }
    },
    created() {
      if(this.token) {
        const fourMonthsAgo = new Date(this.$store.state.user.last_update_password_date);
        fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() + 3);

        console.log(fourMonthsAgo)
        if(fourMonthsAgo < new Date()) {
          this.dialog.password = true
        }
      }
      const d = {}

      document.addEventListener ('mousedown', e => {
        const closestDialog = e.target.closest('.v-dialog.v-dialog--active')
        if (e.button === 0 && closestDialog != null && e.target.classList.contains('v-card__title')) { 
          d.el = closestDialog
          d.mouseStartX = e.clientX
          d.mouseStartY = e.clientY
          d.elStartX = d.el.getBoundingClientRect().left
          d.elStartY = d.el.getBoundingClientRect().top
          d.el.style.position = 'fixed'
          d.el.style.margin = 0
          d.oldTransition = d.el.style.transition
          d.el.style.transition = 'none'
        }
      })

      document.addEventListener ('mousemove', e => {
          if (d.el === undefined) return

          d.el.style.left = Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
          ) + 'px'
          d.el.style.top = Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
          ) + 'px'
      })

      document.addEventListener ('mouseup', () => {
          if (d.el === undefined) return
          d.el.style.transition = d.oldTransition
          d.el = undefined
      })

      setInterval(() => { 
        const dialog = document.querySelector('.v-dialog.v-dialog--active')
        if (dialog === null) return
        dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + 'px'
        dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + 'px'
      }, 100)
    },
    methods: {
      
    }
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
  }

  #content {
    padding: 0px;
  }
</style>